<template>
    <div>
        <div style="cursor:pointer;">
            <i class="fa fa-fw fa-chevron-right" @click="toggle(tree.id)" v-show="!showing(tree.id)"/>
            <i class="fa fa-fw fa-chevron-down" @click="toggle(tree.id)" v-show="showing(tree.id)"/>

            <input type="checkbox"
                   @change="selectLeaf"
                   v-model="selected"
                   :name="'label-' + tree.id"
                   :id="'label-' + tree.id">

            <label :for="'label-' + tree.id"
                   style="display: inline; color: inherit; font-size: inherit; margin: 0 10px 0 0;">
                <b>{{ tree.name }}</b>
            </label>
        </div>

        <div v-if="tree.children && tree.children.length > 0" v-show="showing(tree.id)" class="x-col">
            <node v-for="child in tree.children" :node="child" :key="child.id" v-on="$listeners" />
        </div>
    </div>
</template>

<script>
import Node from "./ServicesNode"

export default {
    name: 'parent',
    props: {
        tree: Object,
        expanded: Array,
    },
    components: {
        Node
    },
    data: () => ({
        selected: false
    }),
    methods: {
        toggle(id) {
            if (this.showing(id)) {
                this.collapse(id)
            } else {
                this.expand(id)
            }
        },
        collapse(id) {
            this.$emit('collapse', id)
        },
        expand(id) {
            this.$emit('expand', id)
        },
        showing(id) {
            return this.expanded.includes(id)
        },
        selectLeaf() {
            this.$emit('leafChecked', {id: this.tree.id, checked: this.selected, text: this.tree.name});
        }
    },
}
</script>

<style scoped>
    @media (max-width: 500px) {
        .x-col {
            -webkit-column-count: 1;
            -moz-column-count: 1;
            column-count: 1;
        }
    }
    @media (max-width: 900px) and (min-width: 500px) {
        .x-col {
            -webkit-column-count: 2;
            -moz-column-count: 2;
            column-count: 2;
        }
    }
    @media (min-width: 900px) {
        .x-col {
            -webkit-column-count: 3;
            -moz-column-count: 3;
            column-count: 3;
        }
    }
</style>
